export default __webpack_public_path__ + "static/media/vegan-products-in-retail-square.0551a8a3.png";